var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrendingDownFilled = function SvgTrendingDownFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.707 6.293a1 1 0 0 0-1.414 1.414l4.891 4.891c.179.179.352.353.512.488.174.148.396.308.686.402a2 2 0 0 0 1.236 0c.29-.094.512-.254.686-.402a9 9 0 0 0 .512-.488l2.76-2.76c.21-.21.325-.323.414-.4L13 9.43l.01.009c.09.076.205.19.414.4L19.586 16H15a1 1 0 1 0 0 2h7a1 1 0 0 0 1-1v-7a1 1 0 1 0-2 0v4.586l-6.184-6.184a9 9 0 0 0-.511-.488 2 2 0 0 0-.687-.402 2 2 0 0 0-1.236 0c-.29.094-.512.254-.687.402-.159.135-.332.31-.51.488l-2.76 2.76c-.21.21-.326.323-.415.4L8 11.57l-.01-.009a8 8 0 0 1-.414-.4z"
  })));
};
export default SvgTrendingDownFilled;